<template>
<div class="chapter">
<div class="inner_page">
<h1 style="text-align:right; font-size:1.5em;padding-top:4em;">Apartheid’s Festival</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Other2.vue?06a4fe9f